import { createYupRegexValidationAdder } from './createYupRegexValidationAdder';
import { respOrgRegex } from '../regex/respOrgRegex';

/**
 * Adds a method to yup.string that validates the format of a RespOrg.
 * The Yup method that gets created accepts the same optional parameters to override the defaults.
 *
 * @module
 *
 * @param {string} [defaultMessage=({ path }) => `${path} must be a valid RespOrg`] The default message used when the yup method is invoked with no message argument provided
 *
 * @example
 * import { addRespOrgToYup } from '@somosengineering/js-util-lib';
 * import { string, object } from 'yup'
 *
 * // Add the method to Yup
 * addRespOrgToYup();
 *
 * // Using the method in a schema
 * const schema = object({
 *    // Default args
 *    respOrg: string().respOrg(),
 *    // Custom args
 *    respOrg2: string().respOrg(({ path }) => `${path} is not a valid RespOrg`),
 * })
 *
 */
const addRespOrgToYup = createYupRegexValidationAdder({
   validationName: 'respOrg',
   readableName: 'RespOrg',
   regex: respOrgRegex,
});

export { addRespOrgToYup };
